import { render, staticRenderFns } from "./NotesFormDelete.vue?vue&type=template&id=10938844"
import script from "./NotesFormDelete.vue?vue&type=script&lang=js"
export * from "./NotesFormDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports